import React from 'react'

/**
 * Decorative grid-and-waves artwork inside the closing brand band, ported verbatim
 * from the reference design. The gradient/pattern ids are prefixed to keep them
 * from colliding with any other inline SVG mounted on the same page.
 */
const BrandBandWaves = () => (
  <svg
    className='mic-home-artwork'
    viewBox='0 0 1200 250'
    preserveAspectRatio='xMidYMax slice'
    aria-hidden='true'
    focusable='false'
  >
    <defs>
      <pattern id='mic-home-bpgrid' width='48' height='48' patternUnits='userSpaceOnUse'>
        <path d='M48 0 L0 0 0 48' fill='none' stroke='#4fd691' strokeOpacity='.05' strokeWidth='1' />
      </pattern>
      <linearGradient id='mic-home-waveBack' x1='0' y1='0' x2='0' y2='1'>
        <stop offset='0' stopColor='#4fd691' stopOpacity='.14' />
        <stop offset='1' stopColor='#4fd691' stopOpacity='0' />
      </linearGradient>
      <linearGradient id='mic-home-waveFront' x1='0' y1='0' x2='0' y2='1'>
        <stop offset='0' stopColor='#4fd691' stopOpacity='.26' />
        <stop offset='1' stopColor='#4fd691' stopOpacity='.02' />
      </linearGradient>
    </defs>
    <rect x='0' y='0' width='1200' height='250' fill='url(#mic-home-bpgrid)' />
    <path d='M0,150 C160,100 280,190 440,140 S700,70 860,130 S1080,185 1200,120 L1200,250 L0,250 Z' fill='url(#mic-home-waveBack)' />
    <path d='M0,185 C180,150 320,215 500,170 S780,120 940,180 S1120,215 1200,165 L1200,250 L0,250 Z' fill='url(#mic-home-waveFront)' />
    <path d='M0,185 C180,150 320,215 500,170 S780,120 940,180 S1120,215 1200,165' fill='none' stroke='#4fd691' strokeOpacity='.85' strokeWidth='2.5' strokeLinecap='round' />
    <circle cx='500' cy='170' r='4.5' fill='#6ce2a8' />
    <circle cx='940' cy='180' r='4.5' fill='#6ce2a8' />
    <circle cx='220' cy='171' r='3.5' fill='#4fd691' fillOpacity='.8' />
  </svg>
)

export default BrandBandWaves
